import { request } from './request';

export async function getCardFees(
  userId,
  monthlyTurnover,
  acquiringProduct,
  abortController = null,
  handleErrorResponse = null,
) {
  const res = await request(
    `cardfees?amount=${monthlyTurnover}&acquiringProduct=${acquiringProduct}&userId=${userId}`,
    {
      fetchOptions: {
        method: 'GET',
        signal: abortController?.signal || null,
      },
    },
    null,
    // TealiumEvents.terminalsError,
  );

  const isAborted = !!abortController && abortController.signal.aborted;
  if (res?.status === 200) {
    return res.result;
  } else if (handleErrorResponse && !isAborted) {
    handleErrorResponse('error response from the cardfees GET endpoint', null, null, res);
  }
}

export async function getTerminalFees(
  abortController = null,
  optimisationEnabled = false,
  handleErrorResponse = null,
) {
  const res = await request(
    `terminalfees${optimisationEnabled ? '?allDevices=true' : ''}`,
    {
      fetchOptions: {
        method: 'GET',
        signal: abortController?.signal || null,
      },
    },
    null,
    // TealiumEvents.terminalsError,
  );

  const isAborted = !!abortController && abortController.signal.aborted;
  if (res?.status === 200) {
    return res.result;
  } else if (handleErrorResponse && !isAborted) {
    handleErrorResponse('error response from the terminalfees GET endpoint', null, null, res);
  }
}

export async function getOnboardingFees(abortController = null, handleErrorResponse = null) {
  const res = await request(
    `onboardingfees`,
    {
      fetchOptions: {
        method: 'GET',
        signal: abortController?.signal || null,
      },
    },
    null,
    // TealiumEvents.terminalsError,
  );

  const isAborted = !!abortController && abortController.signal.aborted;
  if (res?.status === 200) {
    return res.result;
  } else if (handleErrorResponse && !isAborted) {
    handleErrorResponse('error response from the onboardingfees GET endpoint', null, null, res);
  }
}
